export default __webpack_public_path__ + "static/media/Nottingham.94189b96.png";